module.exports = __webpack_public_path__ + "static/media/Vector.3987a7a9.png";